function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import tokens from '@veneer/tokens';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    direction,
    steps
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var isHorizontal = direction === 'horizontal';
    var shouldContainerIncrease = steps && steps.some(step => step.label && step.label.length > 17);
    var horizontalHeight = isHorizontal && shouldContainerIncrease ? '90px' : '70px';
    var verticalPadding = shouldContainerIncrease && !isHorizontal ? theme.layout.size5 : undefined;
    return {
      container: _objectSpread({
        display: 'flex',
        flexDirection: isHorizontal ? 'row' : 'column',
        height: horizontalHeight,
        padding: isHorizontal ? "0 calc(".concat(tokens.layout.size5, " + ").concat(tokens.layout.size8, ")") : undefined,
        paddingBottom: verticalPadding,
        paddingTop: verticalPadding
      }, highContrastMediaQuery(theme))
    };
  }, [theme, direction, steps]);
};
export default useStyles;